import { Validate } from 'react-hook-form';

import { FormInputFileTypes } from '@/enums/form-input-file-types';
import { bytesToLiteral } from '@/utils/bytes-utils';

export const emailFormValidator = {
  value: new RegExp('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$', 'ig'),
  message: 'Enter a valid email address',
};

export const phoneFormValidator = {
  value: new RegExp(
    '^(\\+\\d{1,3}[- ]?)?\\d{10}$|^\\(\\d{3}\\) \\d{3}-\\d{4}$',
    'ig'
  ),
  message: 'Enter a valid phone number',
};

export const undefinedFormValidator: Validate<unknown, unknown> = () => {
  return true;
};

export const fileSizeFormValidator = (
  maxSize: number
): Validate<FileList, unknown> => {
  return (files: FileList) => {
    if (!(files instanceof FileList) || files.length === 0) return true;

    const file = files[0];

    if (file.size > maxSize) {
      return `File size must be less than ${bytesToLiteral(maxSize)}`;
    }

    return true;
  };
};

export const fileExtensionFormValidator = (
  extensions: FormInputFileTypes[]
): Validate<FileList, unknown> => {
  return (files: FileList) => {
    if (!files || files.length === 0) return true;

    for (const file of Array.from(files)) {
      const fileExtension = file.type;

      if (!extensions.includes(fileExtension as FormInputFileTypes)) {
        return `File extension must be one of ${extensions.join(', ')}`;
      }
    }

    return true;
  };
};

export const hasFileFormValidator = (
  multiple?: boolean
): Validate<FileList, unknown> => {
  return (files: FileList) => {
    if (files && files.length > 0) return true;

    if (multiple) {
      return `At least one file is required.`;
    }
    return `One file is required.`;
  };
};

export const hasSelectedOptionFormValidator = <T>(
  selectedOptions: T | undefined,
  multiple: boolean | undefined
): Validate<T, unknown> => {
  return () => {
    if (
      selectedOptions ||
      (Array.isArray(selectedOptions) && selectedOptions.length > 0)
    )
      return true;

    if (multiple) {
      return `At least one selected option is required.`;
    }
    return `One selected option is required.`;
  };
};
